import type { AboutMenuItem, AboutSeo } from './types';

export const ABOUT_CONTACTS_SEO: AboutSeo = {
  title: 'Контакты Tripster - телефоны и email службы поддержки',
  description:
    'Официальные контакты Tripster - телефоны для России и Европы, email для путешественников и гидов. Напишите в поддержку, чтобы быстро решить вопросы по бронированию, оплате или переносу заказа. Адрес компании и реквизиты на странице.',
  ogTitle: 'Контакты Tripster - телефоны и email службы поддержки',
  ogDescription:
    'Официальные контакты Tripster - телефоны для России и Европы, email для путешественников и гидов. Напишите в поддержку, чтобы быстро решить вопросы по бронированию, оплате или переносу заказа. Адрес компании и реквизиты на странице.',
};

export const ABOUT_MENU_ITEMS: AboutMenuItem[] = [
  { id: 'company', text: 'О компании', type: 'content-page', href: '/about/company/' },
  { id: 'terms', text: 'Пользовательское соглашение', type: 'content-page', href: '/about/terms/' },
  {
    id: 'cancellation_policy',
    text: 'Политика возврата',
    type: 'content-page',
    href: '/about/cancellation_policy/',
  },
  {
    id: 'bonus-policy',
    text: 'Бонусная политика',
    type: 'content-page',
    href: '/about/bonus-policy/',
  },
  {
    id: 'secure_payments',
    text: 'Безопасность платежей',
    type: 'content-page',
    href: '/about/secure_payments/',
  },
  {
    id: 'privacy_policy',
    text: 'Политика обработки персональных данных',
    type: 'content-page',
    href: '/about/privacy_policy/',
  },
  {
    id: 'soglasie-na-reklamnuyu-i-informaczionnuyu-rassylku',
    text: 'Реклама и информационные сообщения',
    type: 'content-page',
    href: '/about/soglasie-na-reklamnuyu-i-informaczionnuyu-rassylku/',
  },
  {
    id: 'soglasie-kandidata',
    text: 'Согласие кандидата',
    type: 'content-page',
    href: '/about/soglasie-kandidata/',
  },
  {
    id: 'soglasie-na-publikaciyu-otzyva',
    text: 'Согласие на публикацию отзыва',
    type: 'content-page',
    href: '/about/soglasie-na-publikaciyu-otzyva/',
  },
  {
    id: 'soglasie-na-publikaciyu-statii',
    text: 'Согласие на публикацию статьи',
    type: 'content-page',
    href: '/about/soglasie-na-publikaciyu-statii/',
  },
  {
    id: 'partners',
    text: 'Партнёрская программа',
    type: 'external-link',
    href: '/partners/',
  },
  {
    id: 'terms_partners',
    text: 'Оферта для партнёров',
    type: 'content-page',
    href: '/about/terms_partners/',
  },
  {
    id: 'terms_organizers',
    text: 'Оферта для организаторов',
    type: 'content-page',
    href: '/about/terms_organizers/',
  },
  {
    id: 'issledovanie-oferta',
    text: 'Оферта на участие в исследовании',
    type: 'content-page',
    href: '/about/issledovanie-oferta/',
  },
  {
    id: 'audio',
    text: 'Правила сотрудничества для аудиогидов',
    type: 'content-page',
    href: '/about/audio/',
  },
  { id: 'contacts', text: 'Контакты', type: 'content-page', href: '/about/contacts/' },
  { id: 'payment', text: 'Cпособы оплаты', type: 'content-page', href: '/about/payment/' },
  {
    id: 'guarantee',
    text: 'Гарантия лучшей цены',
    type: 'content-page',
    href: '/about/guarantee/',
  },
  {
    id: 'organizer-rules-and-standards',
    text: 'Правила и стандарты работы Организаторов на Платформе',
    type: 'content-page',
    href: '/about/organizer-rules-and-standards/',
  },
];
